module.exports = __webpack_public_path__ + "static/media/3DPPA23.053d4a56.jpg";